/* ==========================================================================
   NeverLeafs Redesign 2026 — Blogartikel: het interactieve deel

   Alles hier is aanvulling op een pagina die zonder JavaScript gewoon leest:
   de tekst, het productblok en de vragenlijst staan al in de HTML. Valt dit
   bestand weg, dan verdwijnen alleen de inhoudsopgave, de voortgangsbalk en
   het wisselen tussen collecties.
   ========================================================================== */
(function () {
  'use strict';

  var zachtScrollen = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Springen ----------
     Het thema draait GSAP ScrollSmoother. Die verschuift de inhoud met een
     transform, dus een gewone ankersprong komt naast het doel uit. Bestaat de
     smoother, dan laten we hem het werk doen. */
  function springNaar(doel) {
    var smoother = window.ScrollSmoother && window.ScrollSmoother.get && window.ScrollSmoother.get();
    if (smoother) {
      smoother.scrollTo(doel, zachtScrollen, 'top 90px');
      return;
    }
    var top = doel.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: top, behavior: zachtScrollen ? 'smooth' : 'auto' });
  }

  /* ---------- Vaste elementen losmaken ----------
     Alles wat vast op het scherm moet blijven staan moet buiten .smooth-content
     hangen: binnen een element met een transform is position:fixed niet meer
     vast, maar relatief aan dat element. */
  function maakLos() {
    ['.rd-art__progress', '[data-rd-sticky]'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && el.parentElement !== document.body) document.body.appendChild(el);
    });
  }

  /* ---------- Inhoudsopgave uit de koppen ---------- */
  function bouwInhoud() {
    var body = document.querySelector('[data-rd-body]');
    var lijsten = document.querySelectorAll('[data-rd-toc-list]');
    if (!body || !lijsten.length) return [];

    // Onder de drie koppen is een inhoudsopgave geen hulp maar ruis: de lezer
    // ziet die koppen toch al zonder te scrollen.
    var koppen = [].slice.call(document.querySelectorAll('.rd-art__body h2'));
    if (koppen.length < 3) return [];

    koppen.forEach(function (kop, i) {
      if (!kop.id) kop.id = 'deel-' + (i + 1);
      kop.style.scrollMarginTop = '96px';
    });

    lijsten.forEach(function (lijst) {
      lijst.innerHTML = '';
      koppen.forEach(function (kop) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + kop.id;
        a.textContent = (kop.textContent || '').trim();
        a.setAttribute('data-rd-toc-link', kop.id);
        li.appendChild(a);
        lijst.appendChild(li);
      });
    });

    var toc = document.querySelector('[data-rd-toc]');
    if (toc) {
      toc.hidden = false;
      // Op een breed scherm staat de lijst open, op mobiel kost dat te veel
      // schermruimte voordat de lezer één zin gelezen heeft.
      if (window.innerWidth >= 750) toc.open = true;
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-rd-toc-link]');
      if (!link) return;
      var doel = document.getElementById(link.getAttribute('data-rd-toc-link'));
      if (!doel) return;
      e.preventDefault();
      springNaar(doel);
      // Adresbalk bijwerken zonder een tweede sprong te veroorzaken.
      if (history.replaceState) history.replaceState(null, '', '#' + doel.id);
    });

    return koppen;
  }

  /* ---------- Meelezen: welke kop is in beeld ---------- */
  function volgKoppen(koppen) {
    if (!koppen.length || !('IntersectionObserver' in window)) return;

    var actief = null;
    function markeer(id) {
      if (id === actief) return;
      actief = id;
      var links = document.querySelectorAll('[data-rd-toc-link]');
      for (var i = 0; i < links.length; i++) {
        links[i].classList.toggle('is-active', links[i].getAttribute('data-rd-toc-link') === id);
      }
    }

    // De kop die het dichtst onder de bovenkant van het scherm staat wint.
    var zichtbaar = {};
    var waarnemer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        zichtbaar[e.target.id] = e.isIntersecting;
      });
      var gekozen = null;
      for (var i = 0; i < koppen.length; i++) {
        var kop = koppen[i];
        if (zichtbaar[kop.id]) { gekozen = kop.id; break; }
        if (kop.getBoundingClientRect().top < 120) gekozen = kop.id;
      }
      if (gekozen) markeer(gekozen);
    }, { rootMargin: '-88px 0px -70% 0px', threshold: 0 });

    koppen.forEach(function (kop) { waarnemer.observe(kop); });
  }

  /* ---------- Voortgangsbalk en meeleesbalk ---------- */
  function volgVoortgang() {
    var balk = document.querySelector('[data-rd-progress]');
    var bar = document.querySelector('[data-rd-bar]');
    var sticky = document.querySelector('[data-rd-sticky]');
    var body = document.querySelector('[data-rd-body]');
    var kaart = document.querySelector('.rd-art__card');
    if (!balk || !body) return;

    var bezig = false;
    function meet() {
      bezig = false;
      var doel = kaart || body;
      var top = doel.getBoundingClientRect().top + window.scrollY;
      var hoogte = doel.offsetHeight - window.innerHeight;
      var gelezen = hoogte > 0 ? (window.scrollY - top) / hoogte : 0;
      var pct = Math.min(1, Math.max(0, gelezen));
      balk.style.width = (pct * 100).toFixed(1) + '%';

      var voorbijHero = window.scrollY > top - 40;
      if (bar) bar.classList.toggle('is-visible', voorbijHero && pct < 0.99);
      if (sticky) sticky.classList.toggle('is-visible', pct > 0.12 && pct < 0.92);
    }

    window.addEventListener('scroll', function () {
      if (bezig) return;
      bezig = true;
      window.requestAnimationFrame(meet);
    }, { passive: true });
    window.addEventListener('resize', meet, { passive: true });
    meet();
  }

  /* ---------- Interne knoppen naar het productblok ---------- */
  function initAnkers() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#rd-shop"]');
      if (!link) return;
      var doel = document.getElementById('rd-shop');
      if (!doel) return;
      e.preventDefault();
      springNaar(doel);
    });
  }

  /* ---------- Kapotte afbeeldingen in de tekst ----------
     In vijf artikelen staan afbeeldingen die naar Google Drive wijzen en daar
     niet meer bestaan. Een gebroken-plaatje-icoon met alt-tekst eronder ziet
     eruit als een storing; wegnemen is netter dan tonen. De tekst zelf blijft
     staan, dus er verdwijnt niets wat de lezer nodig heeft. */
  function verbergKapotteAfbeeldingen() {
    var afbeeldingen = document.querySelectorAll('.rd-art__body img');
    for (var i = 0; i < afbeeldingen.length; i++) {
      (function (img) {
        function weg() { img.style.display = 'none'; }
        if (img.complete && img.naturalWidth === 0) weg();
        img.addEventListener('error', weg);
      })(afbeeldingen[i]);
    }
  }

  /* ---------- Productblok: wisselen tussen collecties ---------- */
  function initTabs() {
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.rd-shop__tab');
      if (!tab) return;
      var blok = tab.closest('[data-rd-shop]');
      if (!blok) return;

      var tabs = blok.querySelectorAll('.rd-shop__tab');
      for (var i = 0; i < tabs.length; i++) {
        var aan = tabs[i] === tab;
        tabs[i].classList.toggle('is-active', aan);
        tabs[i].setAttribute('aria-selected', aan ? 'true' : 'false');
        var paneel = document.getElementById(tabs[i].getAttribute('aria-controls'));
        if (paneel) paneel.hidden = !aan;
      }
    });

    // Pijltjestoetsen, zoals een tablijst hoort te werken.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tab = document.activeElement;
      if (!tab || !tab.classList || !tab.classList.contains('rd-shop__tab')) return;
      var blok = tab.closest('[data-rd-shop]');
      if (!blok) return;
      var tabs = [].slice.call(blok.querySelectorAll('.rd-shop__tab'));
      var i = tabs.indexOf(tab);
      var volgende = tabs[e.key === 'ArrowRight' ? i + 1 : i - 1];
      if (!volgende) return;
      e.preventDefault();
      volgende.focus();
      volgende.click();
    });
  }

  function start() {
    maakLos();
    var koppen = bouwInhoud();
    volgKoppen(koppen);
    volgVoortgang();
    initTabs();
    initAnkers();
    verbergKapotteAfbeeldingen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
